// 9fbef606107a605d69c0edbcd8029e5d
import styled, { keyframes } from 'styled-components';

// CSS Animation for Pulsing Effect
const pulseAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${(props) =>
    props.oosBgColor || props.theme.brandSpecificStyles.PROMO_BADGE_BACKGROUND_COLOR};
  border-radius: 8px;
  border: none;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.5s ease-out 0.5s both;
  @media ${(props) => props.theme.mediaQuery.large} {
    top: -29px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    top: -22px;
  }
`;

export const StockText = styled.span`
  color: ${(props) => props.oosTextColor || props.theme.colors.PRIMARY_TEXT_COLOR};
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
  display: flex;
`;

export const StockIndicatorWrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-18px, -18px);
  ${(props) => (props.isDimmed ? `opacity: 0` : `opacity: 1`)};
`;

export const SolidCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  animation: ${pulseAnimation} 3s infinite;
`;

export const OutlineCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid white;
  background-color: transparent;
  position: absolute;
  animation: ${pulseAnimation} 3s infinite;
`;
